import {Preloader} from "components/Preloader";
import {noop} from "lodash";
import {checkUserName} from "modules/actions/user";
import {RequestState} from "modules/enums";
import {getUserStore} from "modules/selectors/user";
import {redirectToMlbLoginForm} from "modules/utils/mlbConfig";
import React, {Fragment, useEffect, PropsWithChildren} from "react";
import {useDispatch, useSelector} from "react-redux";

interface IProps {
	uid: string;
}

export const HOCCheckUserName: React.FC<PropsWithChildren<IProps>> = ({uid, children}) => {
	const dispatch = useDispatch();
	const user = useSelector(getUserStore);

	useEffect(() => {
		dispatch(
			checkUserName({
				uid,
			})
		);
	}, [dispatch, uid]);

	useEffect(() => {
		if (user.checkUserNameRequestState === RequestState.Received && !user.userHasUserName) {
			redirectToMlbLoginForm();
		}

		return noop;
	}, [user]);

	const isValid =
		user.checkUserNameRequestState === RequestState.Received && user.userHasUserName;

	if (isValid) {
		return <Fragment>{children}</Fragment>;
	}

	return <Preloader />;
};
